// import Vue from 'vue';
// import Vuex from 'vuex';
import { createStore as _createStore } from 'vuex';
// roles store
import _ from 'lodash';
import RolesState from './roles/initialState';
import RolesGetters from './roles/getters';
import RolesMutation from './roles/mutations';
// tasks store
import TasksState from './tasks/initialState';
import TasksMutation from './tasks/mutationsShared';
import tasksModelGetters from './tasks/getters';
import tasksModelGettersNew from './tasks/gettersNew';
// resources store
import ResourcesState from './resources/initialState';
import ResourcesGetters from './resources/getters'; // clean module
import ResourcesMutation from './resources/mutationsShared';
// projects store
import ProjectsState from './projects/initialState';
import ProjectsGetters from './projects/getters'; // clean module
import ProjectsMutation from './projects/mutations';
// filters store
import FilterState from './filter/initialState';
import FilterGetters from './filter/getters'; // clean module
import FilterMutation from './filter/mutations'; // clean module
import FilterActions from './filter/actionsShared';

// columns store
import ColumnsState from './columns/initialState';
import columnsGetters from './columns/getters';
// import FilterGetters from './filters/getters'; // clean module
import ColumnsMutation from './columns/mutationsShared'; // clean module
import ColumnsAction from './columns/actionsShared'; // clean module

// board store
import BoardState from './board/initialState';
import BoardGetters from './board/getters';
import BoardMutations from './board/mutations';
import BoardActions from './board/actionsShared';

// header store
import HeaderStore from '../views/header/sharedHeaderStore';

// tooltip store
import TooltipStore from '../views/tooltip/tooltipStore';

// time tracking
import TimeTrackingStore from './timeTracking';

import constants from '$$helpers/constants';
import UserStore from '$$store/user';
import getters from './roles/getters';
import mutations from './roles/mutations';

const store = _createStore({
  namespaced: true,
  state: {
    appMode: constants.APP_MODES.PUBLIC_LINK,
  },
  getters: {
    isBase: state => state.appMode === constants.APP_MODES.BASE,
    isExport: state => state.appMode === constants.APP_MODES.EXPORT,
    isLink: state => state.appMode === constants.APP_MODES.PUBLIC_LINK,
    isHistory: state => state.appMode === constants.APP_MODES.HISTORY,
  },
  modules: {
    roles: {
      namespaced: true,
      state: RolesState,
      getters: RolesGetters,
      mutations: RolesMutation,
    },

    tasksModel: {
      namespaced: true,
      state: TasksState,
      getters: { ...tasksModelGetters, ...tasksModelGettersNew },
      mutations: TasksMutation,
    },

    resourcesModel: {
      namespaced: true,
      state: ResourcesState,
      getters: ResourcesGetters,
      mutations: ResourcesMutation,
    },

    projects: {
      namespaced: true,
      state: ProjectsState,
      getters: ProjectsGetters,
      mutations: ProjectsMutation,
    },

    filter: {
      namespaced: true,
      state: FilterState,
      getters: FilterGetters,
      mutations: FilterMutation,
      actions: FilterActions,
    },

    columns: {
      namespaced: true,
      state: ColumnsState,
      getters: columnsGetters,
      mutations: ColumnsMutation,
      actions: ColumnsAction,
    },

    board: {
      namespaced: true,
      state: BoardState,
      getters: BoardGetters,
      mutations: BoardMutations,
      actions: BoardActions,
    },

    headerView: HeaderStore,

    timeTracking: TimeTrackingStore,
    teamSetting: {
      namespaced: true,
      state: {
        currency: null,
        enableCurrency: false,
        usersAccountRole: [],
      },
      getters: {
        enableCurrency: state => state.enableCurrency,
        getUserAccountRoleIdByUserId: state => id => state.usersAccountRole?.find(item => item.userId === id)?.roleAccountId,
        colors: state => state.colors,
        currency: state => state.currency,
      },
      mutations: {
        setUsersAccountRole(state, data) {
          state.usersAccountRole = data;
        },
        setColors(state, colors) {
          state.colors = { data: colors };
        },
        setCurrency(state, currency) {
          state.currency = currency;
        },
        setEnableCurrency(state, flag) {
          state.enableCurrency = flag;
        },
      },
    },
    user: UserStore,

    tooltip: TooltipStore,
  },

  actions: {
    setData({ commit, dispatch }, payload) {
      let filter = {};

      commit('roles/setData', payload.data.roles);
      commit('teamSetting/setUsersAccountRole', payload.data.roles.usersAccountRole);
      commit('tasksModel/setData', payload.data.tasks);
      commit('resourcesModel/setData', payload.data.resources);
      if (!_.isEmpty(payload.data.multiview)) {
        commit('projects/setDataMultiview', payload.data.multiview);
      } else {
        commit('projects/setData', { project: payload.data.project, customDays: payload.data.customDays });
      }

      commit('timeTracking/setData', payload.data.timeTrackingData);
      dispatch('columns/loadDataShared', payload.data);
      commit('teamSetting/setColors', payload.system.colors);
      commit('teamSetting/setCurrency', payload.system.team.currency);
      commit('teamSetting/setEnableCurrency', payload.system.team.isActiveCurrency);

      if (payload.data.boardView) {
        dispatch('board/setData', payload);
      }

      // filter data
      if (payload.system.filter && typeof payload.system.filter === 'string') {
        filter = JSON.parse(payload.system.filter);
      } else if (payload.system.filter && typeof payload.system.filter !== 'string') {
        filter = payload.system.filter;
      }

      let filterType = 'sharedUrl';

      if (payload.data.boardView) {
        filterType = 'sharedBoard';
      }

      const activeFilter = {};

      activeFilter[payload.data.project.gantt_id || payload.data.project.multiview_id] = filter;
      commit('filter/setActiveFilters', activeFilter);

      // header
      dispatch('headerView/setUIConfig', payload);
      dispatch('headerView/updatePublicUrlInfo', payload);
      dispatch('headerView/loadZoomShared');

      // dispatch('user/getActivities');
    },
  },
});

export default store;
